;(function () {
  'use strict';

  const angular = window.angular;

  Controller.$inject = ['$scope', 'Var', 'AppUtils'];

  angular
    .module('app')
    .component('varForm', {
      template:'<form name="$ctrl.varForm" class="validate" novalidate ng-show="!$ctrl.saving"><div class="modal-header"><button type="button" class="close" ng-click="$ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button> <span translate>{{::($ctrl.var.id ? \'buttons.edit\' : \'buttons.create\')}}</span> <span translate>entities.organization.var.modelName</span></div><div class="modal-body paddingB0"><div class="form-group" show-errors><label class="control-label" for="name-input" translate>entities._all.name</label> <input id="name-input" name="nameInput" ng-model="$ctrl.var.name" translate-attr="::{placeholder: \'entities._all.name\'}" class="form-control" required><p class="help-block" ng-messages="$ctrl.varForm.nameInput.$error"><span ng-message="required">You did not enter a field</span></p></div><div class="form-group" show-errors><label class="control-label" for="businessName-input" translate>entities._all.businessName</label> <input id="businessName-input" name="businessNameInput" ng-model="$ctrl.var.businessName" translate-attr="::{placeholder: \'entities._all.businessName\'}" class="form-control input-sm" required><p class="help-block" ng-messages="$ctrl.updateForm.businessNameInput.$error"><span ng-message="required">You did not enter a field</span></p></div><div class="form-group"><label class="control-label" for="address-input" translate>entities._all.address</label> <input id="address-input" name="address-input" translate-attr="::{placeholder: \'entities._all.address\'}" ng-model="$ctrl.var.address" class="form-control input-sm"></div><div class="form-group"><label class="control-label" translate>entities._all.country</label><div class="select2-sm"><ui-select ng-model="$ctrl.var.countryId" theme="select2"><ui-select-match placeholder="{{\'general._select.a\' | translate}} {{\'entities._all.country\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="country.id as country in $ctrl.countries | filter: {name: $select.search}"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><p class="help-block"></p></div><div class="form-group"><label class="control-label" translate>entities._all.timezone</label><div class="select2-sm"><ui-select ng-model="$ctrl.var.timeZoneId" theme="select2"><ui-select-match placeholder="{{\'general._select.a\' | translate}} {{\'entities._all.timezone\' | translate}}">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="timezone.id as timezone in $ctrl.timeZones | filter: {text: $select.search}"><div ng-bind-html="timezone.text | highlight: $select.search"></div></ui-select-choices></ui-select></div><p class="help-block"></p></div><div class="form-group"><label class="control-label" for="description-input" translate>entities._all.description</label> <textarea id="description-input" name="description-input" ng-model="$ctrl.var.description" class="form-control input-sm"></textarea></div></div><div class="alert alert-warning no-margin text-center" ng-show="$ctrl.saveError">{{$ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="$ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-if="$ctrl.var.id" ng-click="$ctrl.saveVar()" translate>buttons.update</button> <button class="btn btn-primary" ng-if="!$ctrl.var.id" ng-click="$ctrl.saveVar()" translate>buttons.create</button></div></form><div style="position: relative; height: 210px" ng-show="$ctrl.saving"><spinner css-class="\'small\'" show="$ctrl.saving"></spinner></div>',
      controller: Controller,
      bindings: {
        modalInstance: '<',
        resolve: '<',
      },
    });

  function Controller($scope, Var, utils) {
    let vm = this;

    vm.$onInit = function () {
      vm.var = angular.copy(vm.resolve.var || {});
      vm.timeZones = vm.resolve.timeZones;
      vm.countries = vm.resolve.countries;
      vm.saveVar = saveVar;
    };

    function saveVar() {
      if (!vm.varForm.$valid) {
        $scope.$broadcast('show-errors-check-validity');
        return;
      }

      vm.saving = true;
      if (vm.var.id) {
        Var.updateById({
          id: vm.var.id,
        }, {
          name: vm.var.name,
          businessName: vm.var.businessName,
          address: vm.var.address,
          description: vm.var.description,
          timeZoneId: vm.var.timeZoneId,
          countryId: vm.var.countryId,
        })
          .$promise
          .then(response => {
            vm.saving = false;
            vm.modalInstance.close(response);
          })
          .catch(err => {
            console.log(err);
            vm.saveError = utils.getHTTPError(err);
            vm.saving = false;
          });
      } else {
        Var.create({
          name: vm.var.name,
          businessName: vm.var.businessName,
          address: vm.var.address,
          description: vm.var.description,
        })
          .$promise
          .then(response => {
            vm.saving = false;
            vm.modalInstance.close(response);
          })
          .catch(err => {
            console.log(err);
            vm.saveError = utils.getHTTPError(err);
            vm.saving = false;
          });
      }
    }
  }

})();
